import { useCallback } from 'react';
import { ReadEmployeeSkills } from '../../../services/gql/graphql.generated';
import { TaskType } from '../../../services/tasks/task.types';
import { useTasks } from '../../../services/tasks/useTasks';
import { WorkingShift, WorkingShiftSubsection } from '../../../types/daily.types';

export const useTaskMatch = () => {
  const tasksList = useTasks();
  return useCallback(
    (shift: WorkingShift) => (employeeSkills: ReadEmployeeSkills[]) => {
      const tasks = shift.tasks;

      const taskMatch: TaskType[] = [];
      const impossibleTasks: TaskType[] = [];

      tasks.forEach((sub: WorkingShiftSubsection) => {
        let requiredSkillMissing = false;
        let optionalSkillMissing = false;
        const task = tasksList.find((t: TaskType) => sub.typeContext && t.id === sub.typeContext);

        if (task) {
          task.skills.forEach(skill => {
            if (!employeeSkills.find(s => s.skillId === skill)) {
              requiredSkillMissing = true;
            }
          });

          task.optionalSkills.forEach(skill => {
            if (!employeeSkills.find(s => s.skillId === skill)) {
              optionalSkillMissing = true;
            }
          });

          if (requiredSkillMissing) {
            impossibleTasks.push(task);
          } else if (!optionalSkillMissing) {
            taskMatch.push(task);
          }
        }
      });

      return { taskMatch, impossibleTasks };
    },
    [tasksList]
  );
};
